import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { to: "/about", label: "About" },
  { to: "/how-to", label: "How To" },
  { to: "/faq", label: "FAQ" },
  { to: "/vendor-handbook", label: "Vendors" },
  { to: "/trust-safety", label: "Trust & Safety" },
  { to: "/roadmap", label: "Roadmap" },
  { to: "/changelog", label: "Changelog" },
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/guidelines", label: "Guidelines" },
  { to: "/contact", label: "Contact" },
];

/**
 * Global footer rendered on every page inside GateGuard. Two rows:
 * quick nav links + brand attribution. Kept tight so it doesn't
 * compete with page content.
 */
export default function AppFooter() {
  return (
    <footer
      data-testid="app-footer"
      className="mt-16 py-6 border-t border-white/5 text-center text-[10px] font-mono tracking-widest uppercase text-zinc-600 leading-relaxed px-4"
    >
      <nav
        aria-label="Footer navigation"
        data-testid="footer-links"
        className="max-w-3xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-4"
      >
        {FOOTER_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`footer-link-${l.to.slice(1)}`}
            className="text-zinc-500 hover:text-white transition-colors"
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <div data-testid="footer-powered-by">
        Powered by{" "}
        <a
          href="https://lab21g.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-zinc-400 hover:text-white transition-colors"
        >
          LAB21G.com
        </a>
      </div>
      <div className="mt-1 text-zinc-700 normal-case tracking-normal font-sans">
        a Breaking Legends, LLC service
      </div>
    </footer>
  );
}
